module.exports = __webpack_public_path__ + "static/Wage-a3f32bdaacce10244503290672ce1ead.jpg";